var Page = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods and Variables
     * ========================================================================
    */

    return {
        init: function () { }
    };
}();